@let isForcedMobileLayout = forceMobileLayout();
<document-layout [forceMobileLayout]="isForcedMobileLayout">
    <document-sidemenu-section>
        <document-sidemenu-section-header
            [sectionTitle]="'Verknüpfte Dokumente' | translate"
            icon="fas fa-diagram-project"
        ></document-sidemenu-section-header>
        <document-sidemenu-section-empty-message>
            {{ 'Keine verknüpften Dokumente' | translate }}
        </document-sidemenu-section-empty-message>
        <ng-template #processChainCard let-linkedDocument>
            <process-chain-related-document
                [document]="linkedDocument"
                [navigationAvailable]="!!linkedDocument.targetRoute"
            ></process-chain-related-document>
        </ng-template>
        @for (
            linkedDocument of linkedProcessDocuments();
            track linkedDocument.documentType + '|' + linkedDocument.documentId
        ) {
            @if (linkedDocument.targetRoute) {
                <document-sidemenu-card (cardClick)="navigateToLinkedDocument(linkedDocument)">
                    <ng-container
                        *ngTemplateOutlet="processChainCard; context: { $implicit: linkedDocument }"
                    ></ng-container>
                </document-sidemenu-card>
            } @else {
                <document-sidemenu-card>
                    <ng-container
                        *ngTemplateOutlet="processChainCard; context: { $implicit: linkedDocument }"
                    ></ng-container>
                </document-sidemenu-card>
            }
        }
    </document-sidemenu-section>
    <document-sidemenu-section>
        <document-sidemenu-section-header
            [sectionTitle]="'Anhang' | translate"
            icon="fas fa-paperclip"
        ></document-sidemenu-section-header>
        <document-sidemenu-section-empty-message>
            {{ 'Keine Anhänge vorhanden' | translate }}
        </document-sidemenu-section-empty-message>
        @if (invoice().files.length > 0) {
            @for (file of invoice().files; track file.id) {
                <document-sidemenu-card>
                    <document-sidemenu-attachment [file]="file" [removable]="false"></document-sidemenu-attachment>
                </document-sidemenu-card>
            }
        }
    </document-sidemenu-section>

    @if (invoice(); as invoice) {
        <div class="container-fluid">
            <div class="row">
                <div class="mb-2 col-12">
                    <div class="row">
                        <div
                            class="col-sm-12 col-md-6 col-lg-6 mb-2 p-md-2 p-lg-2 p-xl-2"
                            [ngClass]="isForcedMobileLayout ? 'col-xl-6' : 'col-xl'"
                        >
                            <iim-card [header]="headDataHeader">
                                <ng-template #headDataHeader>
                                    <div class="px-3">
                                        <div class="row">
                                            <div class="col">
                                                <h3 class="m-0">
                                                    <em class="fas fa-clock-rotate-left pe-2"></em>
                                                    {{ 'Kopfdaten' | translate }}
                                                </h3>
                                            </div>
                                            <div class="col-auto p-0">
                                                @if (invoice.isCreditNote) {
                                                    <span
                                                        class="badge rounded-pill bg-info-subtle text-info-emphasis me-2 credit-note-badge"
                                                    >
                                                        {{ 'Gutschrift' | translate }}
                                                    </span>
                                                }
                                                <app-invoice-status-display
                                                    [statusId]="invoice.status"
                                                ></app-invoice-status-display>
                                            </div>
                                        </div>
                                    </div>
                                </ng-template>
                                <div class="px-3">
                                    <div class="row" *showOnDebug>
                                        <div class="col">
                                            <strong>ID</strong>
                                        </div>
                                        <div class="col-auto">
                                            <span copyToClipboard>{{ invoice.id }}</span>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col">
                                            <strong>{{ 'Buchungsdatum' | translate }}</strong>
                                        </div>
                                        <div class="col-auto">
                                            @if (invoice.bookingDate) {
                                                {{ invoice.bookingDate | dayjs: 'L LT' }}
                                            } @else {
                                                <i class="text-description">
                                                    {{ 'Kein Buchungsdatum angegeben' | translate }}
                                                </i>
                                            }
                                        </div>
                                    </div>
                                    @if (showCompanyCode()) {
                                        <div class="row">
                                            <div class="col">
                                                <strong>{{ 'Buchungskreis' | translate }}</strong>
                                            </div>
                                            <div class="col-auto">
                                                {{ companyCodeDisplay() }}
                                            </div>
                                        </div>
                                    }
                                    <div class="row">
                                        <div class="col">
                                            <strong>{{ 'Rechnungsdatum' | translate }}</strong>
                                        </div>
                                        <div class="col-auto">
                                            @if (invoice.documentDate) {
                                                {{ invoice.documentDate | dayjs: 'L LT' }}
                                            } @else {
                                                <i class="text-description">
                                                    {{ 'Kein Rechnungsdatum angegeben' | translate }}
                                                </i>
                                            }
                                        </div>
                                    </div>
                                    @if (invoice.paymentUntil) {
                                        <div class="row">
                                            <div class="col">
                                                <strong>{{ 'Fälligkeitsdatum' | translate }}</strong>
                                            </div>
                                            <div class="col-auto">
                                                {{ invoice.paymentUntil | dayjs: 'L' }}
                                            </div>
                                        </div>
                                    }
                                    @if (invoice.paymentDate) {
                                        <div class="row d-none">
                                            <div class="col">
                                                <strong>{{ 'Zahlungsdatum' | translate }}</strong>
                                            </div>
                                            <div class="col-auto">
                                                {{ invoice.paymentDate | dayjs: 'L' }}
                                            </div>
                                        </div>
                                    }
                                    @if (invoice.remark) {
                                        <div class="row my-2">
                                            <div class="col">
                                                <strong>{{ 'Buchungsvermerk' | translate }}:</strong>
                                            </div>
                                            <div class="col-12">
                                                <span class="newlines">
                                                    <em class="fas fa-comment text-description"></em>
                                                    {{ invoice.remark }}
                                                </span>
                                            </div>
                                        </div>
                                    }

                                    <div class="row">
                                        <div class="col">
                                            <strong>{{ 'Rechnungsnummer' | translate }}</strong>
                                        </div>
                                        <div class="col-auto">
                                            @if (invoice.invoiceNumber) {
                                                <span copyToClipboard>{{ invoice.invoiceNumber }}</span>
                                            } @else {
                                                <i class="text-description">
                                                    {{ 'Keine Rechnungsnummer angegeben' | translate }}
                                                </i>
                                            }
                                        </div>
                                    </div>

                                    <div class="row mt-3">
                                        <invoice-process-status-indicator
                                            [invoiceId]="invoice.id"
                                            [invoiceNumber]="invoice.invoiceNumber"
                                        ></invoice-process-status-indicator>
                                    </div>
                                    <div class="row mt-1">
                                        <div class="col">
                                            <invoice-approver-overview
                                                [invoiceId]="invoice.id"
                                                [invoiceStatus]="invoice.status"
                                            ></invoice-approver-overview>
                                        </div>
                                    </div>
                                </div>
                            </iim-card>
                        </div>
                        <div
                            class="col-sm-12 col-md-6 col-lg-6 mb-2 p-md-2 p-lg-2 p-xl-2"
                            [ngClass]="isForcedMobileLayout ? 'col-xl-6' : 'col-xl'"
                        >
                            <iim-card [header]="supplierHeader">
                                <ng-template #supplierHeader>
                                    <h3 class="m-0">
                                        <em class="fas fa-building pe-2"></em>
                                        {{ 'Lieferant' | translate }}
                                    </h3>
                                </ng-template>
                                <div class="px-3">
                                    @if (supplierAddress(); as supplAddress) {
                                        <company-address
                                            [companyAddress]="supplAddress"
                                            [companyNameLine1Override]="
                                                invoice.supplierName | supplierDisplayName: invoice.supplierNumber
                                            "
                                        ></company-address>
                                    } @else {
                                        <div class="alert alert-warning">
                                            {{ 'Kein Lieferant angegeben' | translate }}
                                        </div>
                                    }
                                </div>
                            </iim-card>
                        </div>

                        <div
                            class="col-sm-12 col-md-6 col-lg-6 mb-2 p-md-2 p-lg-2 p-xl-2"
                            [ngClass]="isForcedMobileLayout ? 'col-xl-6' : 'col-xl'"
                        >
                            <iim-card [header]="invoiceAddressHeader">
                                <ng-template #invoiceAddressHeader>
                                    <h3 class="m-0">
                                        <em class="fas fa-file-invoice pe-2"></em>
                                        {{ 'Rechnungsadresse' | translate }}
                                    </h3>
                                </ng-template>
                                <div class="px-3">
                                    @if (invoiceAddress(); as invoiceAddress) {
                                        <company-address [companyAddress]="invoiceAddress"></company-address>
                                    } @else {
                                        <div class="alert alert-warning">
                                            {{ 'Keine Rechnungsadresse angegeben' | translate }}
                                        </div>
                                    }
                                </div>
                            </iim-card>
                        </div>
                        <div
                            class="col-sm-12 col-md-6 col-lg-6 mb-2 p-md-2 p-lg-2 p-xl-2"
                            [ngClass]="isForcedMobileLayout ? 'col-xl-6' : 'col-xl'"
                        >
                            <invoice-activity [invoice]="invoice"></invoice-activity>
                        </div>
                        @if (invoice.messageToBuyer) {
                            <div
                                class="col-sm-12 col-md-6 col-lg-6 mb-2 p-md-2 p-lg-2 p-xl-2"
                                [ngClass]="isForcedMobileLayout ? 'col-xl-6' : 'col-xl'"
                            >
                                <iim-card [header]="messageToBuyerHeader">
                                    <ng-template #messageToBuyerHeader>
                                        <div class="px-3">
                                            <div class="row">
                                                <div class="col">
                                                    <h3 class="m-0">
                                                        <em class="fas fa-comment pe-2"></em>
                                                        {{ 'Nachricht an den Einkauf' | translate }}
                                                    </h3>
                                                </div>
                                            </div>
                                        </div>
                                    </ng-template>
                                    <div class="col">
                                        <div class="alert alert-info">
                                            {{ invoice.messageToBuyer }}
                                        </div>
                                    </div>
                                </iim-card>
                            </div>
                        }
                    </div>
                </div>
                <div class="col-12">
                    <div class="row mb-2">
                        <div class="col p-md-2 p-lg-2 p-xl-2">
                            <iim-card [header]="itemsHeader" [footer]="positionFooter">
                                <ng-template #itemsHeader>
                                    <div class="px-3">
                                        <div class="row">
                                            <div class="col">
                                                <h3 class="m-0">
                                                    <em class="fas fa-file-lines pe-2"></em>
                                                    {{ 'Positionen' | translate }}
                                                </h3>
                                            </div>
                                            @if (isAccountingEditable() && invoice.itemGroups.length > 0) {
                                                <div class="col-auto align-items-right mt-1">
                                                    <button
                                                        class="btn btn-outline-dark me-2"
                                                        (click)="setAllAccountings()"
                                                    >
                                                        <em class="fas fa-file-invoice-dollar"></em>
                                                        {{ 'Für alle Kontierungen setzen' | translate }}
                                                    </button>
                                                </div>
                                            }
                                        </div>
                                    </div>
                                </ng-template>
                                <div class="px-3">
                                    @if (invoice.itemGroups.length === 0) {
                                        <div class="alert alert-warning">
                                            {{ 'Keine Positionen vorhanden' | translate }}
                                        </div>
                                    }
                                    @for (group of invoice.itemGroups; track group.orderNumber) {
                                        <div class="row mb-2">
                                            <div class="col px-0">
                                                <ul class="list-group">
                                                    @if (group.orderNumber) {
                                                        @let displayOrderNumber =
                                                            group.orderErpNumber ?? group.orderNumber;
                                                        <li class="list-group-item px-0 order-group-header">
                                                            <div class="px-3">
                                                                <div class="row">
                                                                    <div class="col fw-bold">
                                                                        <h5>
                                                                            {{ 'Bestellung' | translate }}
                                                                            <span
                                                                                copyToClipboard
                                                                                class="text-primary cursor-pointer"
                                                                                [routerLink]="
                                                                                    '/client/order/' +
                                                                                    group.orderNumber +
                                                                                    '/detail'
                                                                                "
                                                                            >
                                                                                {{ displayOrderNumber }}
                                                                            </span>
                                                                            @if (
                                                                                deviationsByOrderId()[
                                                                                    group.orderNumber
                                                                                ];
                                                                                as deviatingItems
                                                                            ) {
                                                                                <span
                                                                                    class="badge rounded-pill bg-danger-subtle text-danger-emphasis ms-2 order-group-deviation"
                                                                                >
                                                                                    {{ 'Abweichung bei' | translate }}
                                                                                    {{ deviatingItems }}/{{
                                                                                        group.items.length
                                                                                    }}
                                                                                    {{ 'Positionen' | translate }}
                                                                                </span>
                                                                            }
                                                                        </h5>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </li>
                                                    }
                                                    <li class="list-group-item px-3">
                                                        <div class="col pt-3">
                                                            @for (item of group.items; track item.itemId) {
                                                                @let comparison = itemComparisons()[item.itemId];
                                                                @let invoiceUnitName = item.orderUnit | unit;
                                                                @let orderUnitName = comparison?.unit?.orderValue | unit;
                                                                <document-item [imagePreview]="true">
                                                                    <document-item-position-indicator>
                                                                        {{
                                                                            'Position \{\{position\}\}'
                                                                                | translate
                                                                                    : {
                                                                                          position:
                                                                                              item.invoicePosition,
                                                                                      }
                                                                        }}
                                                                        @if (comparison?.linkedToOrder) {
                                                                            @if (comparison.deviationCount > 0) {
                                                                                <span class="text-danger ms-2">
                                                                                    <em
                                                                                        class="fas fa-exclamation-triangle me-1"
                                                                                        aria-hidden="true"
                                                                                    ></em>
                                                                                    @if (comparison.deviationCount === 1) {
                                                                                        {{ '\{\{count\}\} Abweichung' | translate: { count: 1 } }}
                                                                                    } @else {
                                                                                        {{
                                                                                            '\{\{count\}\} Abweichungen'
                                                                                                | translate
                                                                                                    : {
                                                                                                          count: comparison.deviationCount,
                                                                                                      }
                                                                                        }}
                                                                                    }
                                                                                </span>
                                                                            } @else {
                                                                                <span class="text-success ms-2">
                                                                                    <em class="fas fa-check me-1" aria-hidden="true"></em>
                                                                                    {{ 'wie bestellt' | translate }}
                                                                                </span>
                                                                            }
                                                                        }
                                                                    </document-item-position-indicator>
                                                                    <document-item-name>
                                                                        {{ item.name }}
                                                                    </document-item-name>
                                                                    <document-item-description>
                                                                        <p>{{ item.description }}</p>
                                                                    </document-item-description>
                                                                    @if (item.orderPosition; as orderPosition) {
                                                                        <document-item-attribute>
                                                                            <document-item-label>
                                                                                {{ 'Position Bestellung' | translate }}
                                                                            </document-item-label>
                                                                            <document-item-value>
                                                                                {{ orderPosition }}
                                                                            </document-item-value>
                                                                        </document-item-attribute>
                                                                    }
                                                                    @if (item.receiptPosition && item.receiptNumber) {
                                                                        <document-item-attribute [spacingAbove]="true">
                                                                            <document-item-label>
                                                                                {{
                                                                                    'Position Lieferschein' | translate
                                                                                }}
                                                                            </document-item-label>
                                                                            <document-item-value>
                                                                                {{ item.receiptPosition }}
                                                                            </document-item-value>
                                                                        </document-item-attribute>
                                                                        <document-item-attribute [spacingBelow]="true">
                                                                            <document-item-label>
                                                                                {{ 'Lieferscheinnummer' | translate }}
                                                                            </document-item-label>
                                                                            <document-item-value>
                                                                                <span
                                                                                    class="text-primary"
                                                                                    copyToClipboard
                                                                                    (click)="
                                                                                        navigateToReceipt(
                                                                                            item.receiptId,
                                                                                            item.receiptNumber
                                                                                        )
                                                                                    "
                                                                                >
                                                                                    {{ item.receiptNumber }}
                                                                                </span>
                                                                            </document-item-value>
                                                                        </document-item-attribute>
                                                                    }
                                                                    @if (item.orderItemQuantities; as quantities) {
                                                                        <document-item-attribute [spacingAbove]="true">
                                                                            <document-item-label>
                                                                                {{ 'Bestellt' | translate }}
                                                                            </document-item-label>
                                                                            <document-item-value>
                                                                                {{ quantities.orderedQuantity | number: '1.0-2' }}
                                                                                {{ quantities.unit | unit: quantities.orderedQuantity }}
                                                                            </document-item-value>
                                                                        </document-item-attribute>
                                                                        <document-item-attribute>
                                                                            <document-item-label>
                                                                                {{ 'Geliefert' | translate }}
                                                                            </document-item-label>
                                                                            <document-item-value>
                                                                                {{ quantities.deliveredQuantity | number: '1.0-2' }}
                                                                                {{ quantities.unit | unit: quantities.deliveredQuantity }}
                                                                            </document-item-value>
                                                                        </document-item-attribute>
                                                                        <document-item-attribute [spacingBelow]="true">
                                                                            <document-item-label>
                                                                                {{ 'Berechnet' | translate }}
                                                                            </document-item-label>
                                                                            <document-item-value>
                                                                                {{ quantities.invoicedQuantity | number: '1.0-2' }}
                                                                                {{ quantities.unit | unit: quantities.invoicedQuantity }}
                                                                            </document-item-value>
                                                                        </document-item-attribute>
                                                                    }
                                                                    @if (item.articleNumberSupplier) {
                                                                        <document-item-attribute>
                                                                            <document-item-label>
                                                                                {{ 'Artikelnummer' | translate }}
                                                                            </document-item-label>
                                                                            <document-item-value>
                                                                                {{ item.articleNumberSupplier }}
                                                                            </document-item-value>
                                                                        </document-item-attribute>
                                                                    }
                                                                    @if (item.accountingInput) {
                                                                        <document-item-accounting>
                                                                            <accounting-selection-v2
                                                                                [values]="item.accountingInput"
                                                                                [costCenterEditable]="
                                                                                    isAccountingEditable()
                                                                                "
                                                                                [projectEditable]="
                                                                                    isAccountingEditable()
                                                                                "
                                                                                [generalLedgerAccountEditable]="
                                                                                    isAccountingEditable()
                                                                                "
                                                                                [customAccountAssignmentEditable]="
                                                                                    isAccountingEditable()
                                                                                "
                                                                                [companyCodeId]="invoice.companyCodeId ?? ''"
                                                                                [materialGroupId]="
                                                                                    item.materialGroupCode ?? null
                                                                                "
                                                                                (accountingChanged)="
                                                                                    changeAccounting(
                                                                                        $event,
                                                                                        item.itemId,
                                                                                        invoice.id
                                                                                    )
                                                                                "
                                                                                (requiredFieldsCompleteChanged)="
                                                                                    onAccountingValidationChange(
                                                                                        $event,
                                                                                        item.itemId
                                                                                    )
                                                                                "
                                                                                (warningsChanged)="
                                                                                    onAccountingWarningsChange(
                                                                                        $event,
                                                                                        item.itemId
                                                                                    )
                                                                                "
                                                                                (materialGroupCandidateCodesChanged)="
                                                                                    updateMaterialGroupCandidates(
                                                                                        item.itemId,
                                                                                        $event
                                                                                    )
                                                                                "
                                                                                (materialGroupRecommendationSourceLabelChanged)="
                                                                                    updateMaterialGroupRecommendationSourceLabel(
                                                                                        item.itemId,
                                                                                        $event
                                                                                    )
                                                                                "
                                                                                (materialGroupRecommendationReasonLabelChanged)="
                                                                                    updateMaterialGroupRecommendationReasonLabel(
                                                                                        item.itemId,
                                                                                        $event
                                                                                    )
                                                                                "
                                                                            ></accounting-selection-v2>
                                                                            @if (item.materialGroupCode || isMaterialGroupEditable()) {
                                                                                <div class="mt-3">
                                                                                    <material-group-selection
                                                                                        [valueCode]="
                                                                                            item.materialGroupCode ||
                                                                                            undefined
                                                                                        "
                                                                                        [editable]="
                                                                                            isMaterialGroupEditable()
                                                                                        "
                                                                                        [disabled]="
                                                                                            !isMaterialGroupEditable()
                                                                                        "
                                                                                        [recommendedMaterialGroupCodes]="
                                                                                            recommendedMaterialGroupCodesByItemId[
                                                                                                item.itemId
                                                                                            ] ?? null
                                                                                        "
                                                                                        [recommendedSourceLabel]="
                                                                                            recommendedMaterialGroupSourceLabelsByItemId[
                                                                                                item.itemId
                                                                                            ] ?? null
                                                                                        "
                                                                                        [recommendedReasonLabel]="
                                                                                            recommendedMaterialGroupReasonLabelsByItemId[
                                                                                                item.itemId
                                                                                            ] ?? null
                                                                                        "
                                                                                        (materialGroupSelected)="
                                                                                            changeMaterialGroup(
                                                                                                $event?.code,
                                                                                                item.itemId,
                                                                                                invoice.id
                                                                                            )
                                                                                        "
                                                                                        (validationChange)="
                                                                                            onMaterialGroupValidationChange(
                                                                                                $event,
                                                                                                item.itemId
                                                                                            )
                                                                                        "
                                                                                    ></material-group-selection>
                                                                                </div>
                                                                            }
                                                                        </document-item-accounting>
                                                                    }
                                                                    <document-item-price>
                                                                        <document-item-label>
                                                                            {{ 'Einzelpreis' | translate }}
                                                                        </document-item-label>
                                                                        <document-item-value>
                                                                            <display-currency [value]="item.price.unitPrice" [currencyCode]="item.price.currency" />
                                                                        </document-item-value>
                                                                    </document-item-price>
                                                                    <document-item-price>
                                                                        <document-item-label>
                                                                            {{ 'Rabatt' | translate }}
                                                                            <i
                                                                                class="bi bi-info-circle ms-1"
                                                                                [matTooltip]="
                                                                                    'Der Rabatt wird vom Einzelpreis abgezogen und reduziert den Positionsbetrag'
                                                                                        | translate
                                                                                "
                                                                            ></i>
                                                                        </document-item-label>
                                                                        <document-item-value>
                                                                            {{
                                                                                item.discountPercentage ?? 0
                                                                                    | number: '1.0-2'
                                                                            }}
                                                                            %
                                                                        </document-item-value>
                                                                    </document-item-price>
                                                                    <document-item-price>
                                                                        <document-item-label>
                                                                            @let orderedUnitTranslated =
                                                                                item.orderUnit | unit;
                                                                            <span class="font-11">
                                                                                {{ item.quantity }}
                                                                                {{ orderedUnitTranslated }}
                                                                                {{ 'berechnet' | translate }}
                                                                            </span>
                                                                        </document-item-label>
                                                                        <document-item-value>
                                                                            <span class="font-11">
                                                                                <strong>
                                                                                    <display-currency
                                                                                        [value]="item.price.linePrice"
                                                                                        [currencyCode]="item.price.currency"
                                                                                    />
                                                                                </strong>
                                                                            </span>
                                                                        </document-item-value>
                                                                    </document-item-price>
                                                                </document-item>
                                                                @if (comparison) {
                                                                    <invoice-item-order-comparison
                                                                        class="d-block mb-4 invoice-order-comparison"
                                                                        [comparison]="comparison"
                                                                        [invoiceUnit]="invoiceUnitName"
                                                                        [orderUnit]="orderUnitName"
                                                                        [discountPercentage]="item.discountPercentage ?? 0"
                                                                        [hasGoodsReceipt]="!!item.receiptNumber"
                                                                        [creditNote]="isCreditNote()"
                                                                    />
                                                                }
                                                            }
                                                        </div>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    }
                                </div>
                                @if (invoice?.charges && invoice.charges.length > 0) {
                                    <div class="row mt-3 mb-2 mx-auto">
                                        <div class="col">
                                            <h5 class="m-0">
                                                <em class="fas fa-square-plus pe-1"></em>
                                                {{ 'Zusatzkosten' | translate }}
                                            </h5>
                                        </div>
                                    </div>

                                    @for (charge of invoice.charges; track charge) {
                                        <div class="row px-2">
                                            <div class="col">
                                                <div class="p-3 mb-3 article additional-costs">
                                                    <div class="row mb-2">
                                                        <div class="col-12 fw-bold">
                                                            {{ charge.name }}
                                                        </div>
                                                    </div>

                                                    @if (charge.description) {
                                                        <div class="row mb-1">
                                                            <div class="col-md-2 col-8">
                                                                {{ 'Beschreibung' | translate }}
                                                            </div>
                                                            <div
                                                                class="col-md-10 col-12 text-md-start text-end text-break"
                                                            >
                                                                {{ charge.description }}
                                                            </div>
                                                        </div>
                                                    }

                                                    @if (charge.internalNote) {
                                                        <div class="row mb-1">
                                                            <div
                                                                class="col-md-2 col-8 d-flex align-items-center gap-1 flex-wrap"
                                                            >
                                                                {{ 'Interner Kommentar' | translate }}
                                                                <em
                                                                    class="fas fa-circle-info text-muted"
                                                                    tabindex="0"
                                                                    [matTooltip]="charge.internalNote"
                                                                    matTooltipShowDelay="200"
                                                                ></em>
                                                            </div>
                                                            <div
                                                                class="col-md-10 col-12 text-md-start text-end text-muted small text-break"
                                                            >
                                                                {{ charge.internalNote }}
                                                            </div>
                                                        </div>
                                                    }

                                                    @if (charge.articleNumberSupplier) {
                                                        <div class="row mb-1">
                                                            <div class="col-md-2 col-8">
                                                                {{ 'Artikelnummer Lieferant' | translate }}
                                                            </div>
                                                            <div class="col-md-8 col-4 text-end text-md-start">
                                                                <span copyToClipboard>
                                                                    {{ charge.articleNumberSupplier }}
                                                                </span>
                                                            </div>
                                                        </div>
                                                    }

                                                    @if (charge.chargeType) {
                                                        <div class="row mb-1">
                                                            <div class="col-md-2 col-8">
                                                                {{ 'Typ' | translate }}
                                                            </div>
                                                            <div class="col-md-8 col-4 text-end text-md-start">
                                                                {{ (chargeTypeLabels[charge.chargeType] ?? charge.chargeType) | translate }}
                                                            </div>
                                                        </div>
                                                    }

                                                    @if (charge.articleNumberCustomer) {
                                                        <div class="row mb-1">
                                                            <div class="col-md-2 col-8">
                                                                {{ 'Artikelnummer Mandant' | translate }}
                                                            </div>
                                                            <div class="col-md-8 col-4 text-end text-md-start">
                                                                {{ charge.articleNumberCustomer }}
                                                            </div>
                                                        </div>
                                                    }

                                                    <div class="row mb-1">
                                                        <div class="col-md-2 col-8">
                                                            {{ 'Einzelpreis' | translate }}
                                                        </div>
                                                        <div class="col-md-8 col-4 text-end text-md-start">
                                                            @if (charge.price?.amount && charge.price?.currency) {
                                                                <display-currency [value]="charge.price.amount" [currencyCode]="charge.price.currency" />
                                                            }
                                                        </div>
                                                    </div>

                                                    <div class="row mb-1">
                                                        <div class="col-md-2 col-8">
                                                            {{ 'Steuer %' | translate }}
                                                        </div>
                                                        <div class="col-md-8 col-4 text-end text-md-start">
                                                            {{ charge.taxInPercent / 100 | percent: '1.0-0' }}
                                                        </div>
                                                    </div>

                                                    <div class="row border-top pt-2 mt-2">
                                                        <div
                                                            class="col-md-4 text-start text-md-end fw-bold offset-md-8 col-12"
                                                        >
                                                            <div class="d-flex justify-content-between">
                                                                <div>{{ 'Nettobetrag' | translate }}</div>
                                                                @if (charge.price?.amount && charge.price?.currency) {
                                                                    <div>
                                                                        <display-currency [value]="charge.price.amount" [currencyCode]="charge.price.currency" />
                                                                    </div>
                                                                }
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    }
                                }

                                <ng-template #positionFooter>
                                    <div class="col">
                                        <div class="row justify-content-end">
                                            <div class="col-auto">
                                                <div class="document-price">
                                                    <div class="row">
                                                        <div class="col">
                                                            <strong>{{ 'Netto Preis' | translate }}</strong>
                                                        </div>
                                                        <div class="col-auto">
                                                            @if (
                                                                invoice.price.totalNetPrice !== null &&
                                                                invoice.price.currency !== null
                                                            ) {
                                                                <display-currency [value]="invoice.price.totalNetPrice" [currencyCode]="invoice.price.currency" />
                                                            } @else {
                                                                <i class="text-muted">
                                                                    {{
                                                                        'keine Preisinformationen vorhanden' | translate
                                                                    }}
                                                                </i>
                                                            }
                                                        </div>
                                                    </div>
                                                    @if (invoice.price.taxes !== null) {
                                                        @for (tax of invoice.price.taxes; track tax.percent) {
                                                            <div class="row">
                                                                <div class="col">
                                                                    <strong>
                                                                        {{
                                                                            'zzgl. MwSt. \{\{percent\}\}%'
                                                                                | translate
                                                                                    : {
                                                                                          percent:
                                                                                              tax.percent
                                                                                              | number: '1.2-2',
                                                                                      }
                                                                        }}
                                                                    </strong>
                                                                </div>
                                                                <div class="col-auto">
                                                                    @if (invoice.price.currency !== null) {
                                                                        <display-currency [value]="tax.amount" [currencyCode]="invoice.price.currency" />
                                                                    } @else {
                                                                        <i class="text-muted">
                                                                            {{
                                                                                'keine Preisinformationen vorhanden'
                                                                                    | translate
                                                                            }}
                                                                        </i>
                                                                    }
                                                                </div>
                                                            </div>
                                                        }
                                                    }
                                                    <div class="row">
                                                        <div class="col">
                                                            <strong>{{ 'Brutto Preis' | translate }}</strong>
                                                        </div>
                                                        <div class="col-auto">
                                                            @if (
                                                                invoice.price.totalGrossPrice !== null &&
                                                                invoice.price.currency !== null
                                                            ) {
                                                                <display-currency [value]="invoice.price.totalGrossPrice" [currencyCode]="invoice.price.currency" />
                                                            } @else {
                                                                <i class="text-muted">
                                                                    {{
                                                                        'keine Preisinformationen vorhanden' | translate
                                                                    }}
                                                                </i>
                                                            }
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </ng-template>
                            </iim-card>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }
</document-layout>
